/* eslint-disable import/prefer-default-export */

export const getOptimizedAllQuests = (filterType, page, token) => ({
  type: 'GET_OPTIMIZED_ALL_QUESTS',
  payload: {
    filterType,
    page,
    token,
  },
});

export const getAllGuestQuests = () => ({
  type: 'GET_GUEST_QUESTS',
  payload: {},
});

export const getOptimizedEndedQuests = (filterType, page, token) => ({
  type: 'GET_OPTIMIZED_ENDED_QUESTS',
  payload: {
    filterType,
    page,
    token,
  },
});

export const getSearchLightGames = (token, showLoading = true) => ({
  type: 'GET_SEARCHLIGHT_GAMES',
  payload: {
    token,
    showLoading,
  },
});

export const getSearchLightGameInfo = (gameId) => ({
  type: 'GET_SEARCHLIGHT_GAME_INFO',
  payload: {
    gameId,
  },
});

export const likeSearchLightGame = (gameId, token, currentUser) => ({
  type: 'LIKE_SEARCHLIGHT_GAME',
  payload: {
    gameId,
    token,
    currentUser,
  },
});

export const unlikeSearchLightGame = (gameId, token, currentUserId) => ({
  type: 'UNLIKE_SEARCHLIGHT_GAME',
  payload: {
    gameId,
    token,
    currentUserId,
  },
});
